import {request} from "../../Base/HTTP";

export async function getFinanceStatistics(data) {
    return await request('/api/statistic-finances', data);
}

export async function getHRStatistics(data) {
    return await request('/api/statistic-hr', data);
}